import { API_VERSION_ESYMANDANT, fetchHandler, HTTP_METHOD, limiter } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const postLogin = (username, password) => {
    const payload = {
        'Username': username,
        'Password': password,
    }

    // API_VERSION_ESYMANDANT + 
    const request = fetchRequestBuilder('authenticate/login', HTTP_METHOD.POST, payload, true, false, true)

    // request.data.credentials = 'include'

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}